import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDateArterio from "./SelectDateArterio.jsx";
import { useTranslation } from '../../../../language';

export default function BloodArterioWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_athero')}
      specify={t('page_sp_arteriosclerosis_prevention')}

      >

      {/* Main Page Content */}

       <SelectDateArterio />


    </PageProtectedLayout>

  );
}
